import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  type ReactNode,
} from 'react';

import { send } from 'loot-core/src/platform/client/fetch';

type ServerContextValue = {
  version: string;
};

const ServerContext = createContext<ServerContextValue>({
  version: '',
});

export const useServerVersion = () => useContext(ServerContext).version;

async function getServerVersion() {
  const result = await send('get-server-version');
  if ('version' in result) {
    return result.version;
  }
  return '';
}

export function ServerProvider({ children }: { children: ReactNode }) {
  const [version, setVersion] = useState('');

  useEffect(() => {
    async function run() {
      setVersion(await getServerVersion());
    }
    run();
  }, []);

  return (
    <ServerContext.Provider
      value={{
        version: version ? `v${version}` : 'N/A',
      }}
    >
      {children}
    </ServerContext.Provider>
  );
}
